import styled from "styled-components";

const CIRCLE_SWITCH = styled.section`
  width: 20px;
  height: 20px;
  border: 1px solid var(--swiper-color);
  border-radius: 50%;
  background-color: ${props => props.$filled ? 'var(--swiper-color)' : 'transparent'};

  &:hover {
    cursor: pointer;
  }
`;

export default CIRCLE_SWITCH;